export const s3details = {
    bucketName: "",
    region: "",
    accessKeyId: "",
    secretAccessKey: "",
  };
  